import { render, staticRenderFns } from "./AddItemDialog.vue?vue&type=template&id=32536f0c&"
import script from "./AddItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports